import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { SpecialistAssignmentService } from '@/lib/services/specialist-assignment-service'
import { useToast } from '@/hooks/use-toast'
import type { SpecialistWithAssignments } from '@/types/specialist-assignment'

export function useAdminSpecialists() {
  const { toast } = useToast()
  const queryClient = useQueryClient()

  const {
    data: specialists = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['admin-specialists'],
    queryFn: () => SpecialistAssignmentService.getAllAssignments(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false, // Don't refetch on window focus
    refetchOnMount: false, // Don't refetch on component mount if data exists
  })

  const refreshMutation = useMutation({
    mutationFn: () => SpecialistAssignmentService.getAllAssignments(),
    onSuccess: (data) => {
      queryClient.setQueryData(['admin-specialists'], data)
      toast({
        title: 'Refreshed',
        description: 'Specialist assignments reloaded'
      })
    },
    onError: (error) => {
      console.error('Error refreshing assignments:', error)
      toast({
        variant: 'destructive',
        title: 'Error',
        description: 'Failed to refresh specialist assignments'
      })
    }
  })

  return {
    specialists,
    isLoading,
    error,
    refresh: () => refreshMutation.mutate(),
    isRefreshing: refreshMutation.isPending
  }
}
